exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3y0YFjirBxFndt9kz7BG6F{font-size:17px;font-weight:300;font-weight:600}html[dir] ._1T5r0Uj1ug4a81Yr7Cw_Ik{border-bottom:1px solid \"[theme:neutralLight, default:#eaeaea]\";margin-bottom:14px}html[dir] .ByIFDk6D1w1V99dMR55Vc{margin-top:14px;margin-bottom:26px}.OGZ-gD8_cJRlH9bvvxZnI{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;min-height:50vh}html[dir] .OGZ-gD8_cJRlH9bvvxZnI{text-align:center}._31DaLqrUup3UyukNlgYIkR{font-size:17px;font-weight:300;color:\"[theme:neutralPrimary, default:#333333]\"}html[dir] ._31DaLqrUup3UyukNlgYIkR{text-align:center;padding-top:36px}", ""]);

// exports
exports.locals = {
	"header": "_3y0YFjirBxFndt9kz7BG6F",
	"section": "_1T5r0Uj1ug4a81Yr7Cw_Ik",
	"content": "ByIFDk6D1w1V99dMR55Vc",
	"centralizedMessage": "OGZ-gD8_cJRlH9bvvxZnI",
	"mainMessageText": "_31DaLqrUup3UyukNlgYIkR"
};